import React from "react";
import { useLocation } from "react-router-dom";
import PageHeader from "../common/PageHeader";

export default function LegalPage() {
	const { pathname } = useLocation();
	const isPrivacy = pathname.includes("privacy");

	return (
		<div>
			<PageHeader title={isPrivacy ? "Privacy Policy" : "Terms of Service"} />
			<div className="card p-4">
				<p className="text-muted">
					{isPrivacy
						? "This page describes how Ordr collects, uses, and protects your company and account data across the buyer platform."
						: "By using Ordr Buyer Central you agree to the terms governing bid requests, orders, payments, and use of the platform."}
				</p>
				<p className="text-muted mb-0">
					For the full, current agreement, contact your Ordr account representative or visit the Ordr web portal.
				</p>
			</div>
		</div>
	);
}
